import React, { useCallback, useEffect } from 'react'
import type { FC } from 'react'
import { useRecoilCallback, useRecoilValue } from 'recoil'
import {
  deleteTemplateCallback,
  initCallback,
  resetCallback,
  upsertMessageCallback 
} from './recoil/callbacks/callbacks'
import Header from './components/Header'
import { useHistory } from 'react-router-dom'
import iconMessage from '../../img/email-benvenuto-1.svg'
import { useIntl } from 'react-intl'
import { getLang, notifyParent } from 'mailup-react-helpers'
import { pageState } from '../../state/page'
import Page from 'Containers/Page'
import type { composerData } from './types'
import { composerState } from './recoil/states/page'

const RcsList: FC = () => {
  const intl = useIntl()
  const { loading, errorMessage, status } = useRecoilValue(pageState)
  const {
    token,
    dynamicFields,
    senderPhoneNumbers,
    senderAlias
  } = useRecoilValue(composerState)
  const init = useRecoilCallback(initCallback, [])
  const resetState = useRecoilCallback(resetCallback, [])
  const history = useHistory()
  const upsertMessage = useRecoilCallback(upsertMessageCallback, [])
  const deleteTemplate = useRecoilCallback(deleteTemplateCallback, [])
  useEffect(() => {
    
    init()

    return () => {
      resetState()
    }
  }, [init, resetState])

  // biome-ignore lint/correctness/useExhaustiveDependencies: <explanation>
  const composerRef = useCallback((el: HTMLDivElement | null): void => {
    
    if (el !== null && token !== "") {
      // @ts-ignore
      const agentListRoot = window.ReactDOM.createRoot(
        document.getElementById('template-list')
      )
   
      agentListRoot.render(
          // @ts-ignore
        React.createElement(window.AgileComposer.Main, {
          language: getLang(),
          token: token,
          command: 'template-list',
          variables: dynamicFields,
          senderPhoneNumbers: senderPhoneNumbers,
          senderAliases: senderAlias,
          callback: callback,
          customerUi: {
            'generic.colors.primary': '#16A7CD',
            'generic.colors.hover': '#1286A4',
            'generic.colors.text': '#252525',
            'generic.colors.hamburger': '#252525',
            'generic.colors.text.light': '#7c7c7c',
            'generic.borders.radius': '4px',
            'templates.create.icon': iconMessage,
            'templates.create.title': intl.formatMessage({
              id: 'Load.Rcs.CreateNewMessage'
            }),
            'templates.create.description': intl.formatMessage({
              id: 'Load.Rcs.CreateNewMessageDescription'
            })
            // 'agents.create.icon': 'assets/icona-add-rcs.svg',
            // 'agents.create.title': 'Crea un nuovo Mittente RCS',
            // 'agents.create.description':
            //   'Massimizza l’engagement dei tuoi destinatari con lo standard RCS. Utilizza Emoji per rendere accattivanti i tuoi messaggi, crea call-to-action efficaci e metti in mostra i tuoi prodotti'
          }
        
        })
      )
    }
  },[token])

  const callback = async (action:string, data:composerData) => {
    switch (action) {
      case 'template-selected-for-send': {
       
        const ret = await upsertMessage(data.templateId)
      
          history.push(
            `/messages/rcs/sending/${data.agentId}/${ret !== null ? ret.IdMessage: ""}`
          )
        
        break
      }
        
      case 'update-template':
      case 'new-template':
        upsertMessage(data.templateId)
        break
      case 'delete-template':
        deleteTemplate(data.templateId)
        break
      case 'missing-senders-numeric':
        notifyParent('redirectMainFrame', [
          'form_upd_nl.aspx?visualmode=1&tab=mittenti'
        ])
        break
      case 'missing-senders-alias':
        notifyParent('redirectMainFrame', [
          'settings_app_redirector.aspx?r=/settings/smsalias/0'
        ])
        break
    }
  }

 


  return (
    <>
      <Header />
       <Page onReload={init}>
        {errorMessage === undefined && !loading && status==="ready" && token !== "" && (
            <div id='template-list' className='composer' ref={composerRef} />
        )}
      </Page>
    </>
  )
}

export default RcsList
